/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-wrapper[_ngcontent-%COMP%]{min-height:80px;display:flex;flex-direction:column;justify-content:space-between}.alert-wrapper[_ngcontent-%COMP%]   .mat-dialog-actions[_ngcontent-%COMP%]{min-height:auto;margin-bottom:0;padding-bottom:0}"];
export { styles as styles };
